export default class FaqAccordion {
  constructor() {
    $(window).load(function () {
      $(".faq__question").on("click", function () {
        $(this).toggleClass("faq__question--open"), $(this).next().slideToggle(200);
      }),
        $(".faq__answer__close").on("click", function () {
          $(this).parent().prev().toggleClass("faq__question--open"),
            $(this).parent().slideUp(200);
        });
    });
  }
}
